import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { RmaMasterDetailModel, RmaMasterModel } from 'src/app/shared/models/rma.model';
import { UserModel } from 'src/app/shared/models/user.model';
import { RmaMasterService } from 'src/app/shared/services/rma-master.service';
import { UserService } from 'src/app/shared/services/user.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-rma-list',
  templateUrl: './rma-list.component.html',
  styleUrls: ['./rma-list.component.css']
})
export class RmaListComponent implements OnInit {
  users : UserModel [];
  thisData : MatTableDataSource<any>;
  displayColumn : string[];// = ['date', 'client', 'createby', 'status', 'actions'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;
  //dialogConfig = new MatDialogConfig();
  private sub: any;
  type: string;
  title : string;

  constructor(
    private userService : UserService,
    private service : RmaMasterService,
    private router : Router,
    private route: ActivatedRoute,
    //private toastr : ToastrService
    private gnotify : GlobalNotification
    ) {
  }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
       this.type = params['type'];

       console.log("type : " + this.type);

       if(this.type != null)
       {
        this.userService.getUserList().subscribe(
          res=>{
            this.users = res as UserModel [];
            this.refreshList();
          },
          err=>{}
        );

        this.initialize();

       }
       // In a real app: dispatch action to load the details here.
    });
  }

  getStatusString(status)
  {
    return GlobalConstants.getStatusString(status);
  }

  getCustomerString(type)
  {
    return GlobalConstants.getCustomerString(type);
  }
  getStatusColor(status)
  {
    return GlobalConstants.getStatusColor(status);
  }

  getNextStatusString(type, status)
  {
    return this.getStatusString(GlobalConstants.getNextProcessStatus(type, status));
  }
  getRmaTypeString(type)
  {
    return GlobalConstants.getRmaTypeString(type);
  }

  getCountryString(code)
  {
    return GlobalConstants.getCountryString(code);
  }

  showArrivalIcon(type, status, tag)
  {
    //var result = (GlobalConstants.isArrived(status) && tag)

    //console.log("showArrivalIcon : " + status + "," + result);
    return (GlobalConstants.isArrived(GlobalConstants.getNextProcessStatus(type, status)) && tag);
  }

  refreshList()
  {

    this.service.getListbyStatus(this.type).subscribe(
      res => {
        let array = res as RmaMasterDetailModel[];
          let result = array.map(
            obj => {
              obj.createByUser = this.users.find(item => item.id === obj.createBy);
              obj.statusByUser = this.users.find(item => item.id === obj.statusBy);
              return {...obj}
            }
          );

        this.thisData = new MatTableDataSource(array);
        this.thisData.sort = this.sort;
        this.thisData.paginator = this.paginator;
        this.applyFilter();
         console.log("refreshList : " + this.thisData.data.length);
       },
       err =>{
         console.log(err);
       }
    );

  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter()
  {

    console.log("applyFilter : " + this.searchKey);
    if(this.searchKey != null)
    {
      this.thisData.filter = this.searchKey.trim().toLowerCase();
      /*
      if(this.searchKey == "canada")
      {
        console.log("canada : " + this.searchKey);
      }*/

    }
  }

  onDetail(rmaId)
  {
    this.router.navigateByUrl('/rma-detail/' + rmaId);
  }

  onDelete(rmaId)
  {
    if(!confirm("Are you sure to delete this file?")) return;

    this.service.deleteData(rmaId).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "RMA Request");
        this.gnotify.showSnackBar('RMA Request', 'Submitted successfully', "warning");
        this.searchKey = "";
        this.refreshList();
      },
      err=>{
        console.log(err);
      }
    );
  }

  initialize()
  {
    switch(this.type)
    {
        case 'standby':
          this.title = "RMA - Waiting for Approval";
          this.displayColumn = ['createTime', 'client','clientType', 'destination', 'rmaTypeRequested', 'createby', 'actions'];
          break;
        case 'close':
          this.title = "RMA - Closed";
          this.displayColumn = ['rmaCode', 'client','clientType', 'destination', 'closeby', 'closeTime', 'actions'];
          break;

        case 'inprogress':
          this.title = "RMA - In Process";
          this.displayColumn = ['rmaCode', 'client','clientType', 'destination', 'status', 'statusby', 'statusTime', 'next', 'actions'];
          break;
      }

  }


}
